document.addEventListener('click', function (event) {


  /*
   * Only respond to the variant image
   */
  const image = event.target.closest('.intVariantImgCard');

  if (image) {

    event.preventDefault();
    event.stopPropagation();

    /*
     * Find the Quick Order modal
     */
    const quickOrderModal = image.closest(
      'quick-order-list, .quick-order-list, .quick-order-modal'
    );

    if (!quickOrderModal) {
      console.log('Quick Order modal not found');
      return;
    }

    const preview = document.getElementById(
      'int-quick-order-image-preview'
    );

    const previewImage = document.getElementById(
      'int-quick-order-image-preview__image'
    );

    if (!preview || !previewImage) {
      console.log('Quick Order image preview not found');
      return;
    }

    /*
     * Get large image
     */
    const previewImageUrl =
      image.getAttribute('data-preview-image') ||
      image.src;

    if (!previewImageUrl) {
      return;
    }

    /*
     * Set preview image
     */
    previewImage.src = previewImageUrl;
    previewImage.alt = image.alt || '';

    /*
     * Remember clicked image
     */
    preview._targetImage = image;

    /*
     * Show preview
     */
    preview.classList.add(
      'int-quick-order-image-preview--active'
    );

    preview.setAttribute(
      'aria-hidden',
      'false'
    );

    /*
     * Position next to clicked image
     */
    positionPreview();

    return;
  }


  /*
   * Close preview
   */
  const closeButton = event.target.closest(
    '[data-int-quick-order-image-close]'
  );

  if (closeButton) {

    event.preventDefault();
    event.stopPropagation();

    closePreview();

    return;
  }


  /*
   * Close when clicking outside
   */
  const preview = document.getElementById(
    'int-quick-order-image-preview'
  );

  if (
    preview &&
    preview.classList.contains(
      'int-quick-order-image-preview--active'
    ) &&
    !event.target.closest(
      '#int-quick-order-image-preview'
    )
  ) {
    closePreview();
  }

});


function positionPreview() {

  const preview = document.getElementById(
    'int-quick-order-image-preview'
  );

  if (
    !preview ||
    !preview._targetImage ||
    !preview.classList.contains(
      'int-quick-order-image-preview--active'
    )
  ) {
    return;
  }

  const image = preview._targetImage;

  const imageRect = image.getBoundingClientRect();

  const previewWidth = preview.offsetWidth;
  const previewHeight = preview.offsetHeight;

// Hide when image is outside viewport
  const imageVisible =
    imageRect.bottom > 0 &&
    imageRect.top < window.innerHeight &&
    imageRect.right > 0 &&
    imageRect.left < window.innerWidth;

  if (!imageVisible) {
    preview.classList.remove(
      'int-quick-order-image-preview--active'
    );
    return;
  }
  
  const gap = 12;
  const viewportPadding = 10;

  let left;
  let top;

  let position = 'bottom';


  /*
   * ==========================================
   * 1. FIRST PRIORITY - BOTTOM
   * ==========================================
   */

  top = imageRect.bottom + gap;

  /*
   * Align preview center with main image center
   */
left = imageRect.left;


  /*
   * Check if there is enough space BELOW
   */
  const enoughBottomSpace =
    top + previewHeight <=
    window.innerHeight - viewportPadding;


  if (enoughBottomSpace) {

    position = 'bottom';

  } else {

    /*
     * ==========================================
     * 2. SECOND PRIORITY - RIGHT
     * ==========================================
     */

    left = imageRect.right + gap;

    top =
      imageRect.top +
      (imageRect.height / 2) -
      (previewHeight / 2);


    const enoughRightSpace =
      left + previewWidth <=
      window.innerWidth - viewportPadding;


    if (enoughRightSpace) {

      position = 'right';

    } else {

      /*
       * ==========================================
       * 3. THIRD PRIORITY - LEFT
       * ==========================================
       */

      left =
        imageRect.left -
        previewWidth -
        gap;

      position = 'left';
    }
  }


  /*
   * ==========================================
   * KEEP INSIDE VIEWPORT
   * ==========================================
   */

  if (
    left + previewWidth >
    window.innerWidth - viewportPadding
  ) {
    left =
      window.innerWidth -
      previewWidth -
      viewportPadding;
  }

  if (left < viewportPadding) {
    left = viewportPadding;
  }

  if (
    top + previewHeight >
    window.innerHeight - viewportPadding
  ) {
    top =
      window.innerHeight -
      previewHeight -
      viewportPadding;
  }

  if (top < viewportPadding) {
    top = viewportPadding;
  }


  /*
   * ==========================================
   * APPLY POSITION
   * ==========================================
   */

  preview.style.position = 'fixed';
  preview.style.left = left + 'px';
  preview.style.top = top + 'px';


  /*
   * ==========================================
   * ARROW
   * ==========================================
   */

  let arrowTop;
  let arrowLeft;

  if (position === 'bottom') {

    /*
     * Arrow points UP
     */
    arrowLeft =
      imageRect.left +
      (imageRect.width / 2) -
      left -
      7;

    preview.style.setProperty(
      '--preview-arrow-left',
      arrowLeft + 'px'
    );

    preview.style.setProperty(
      '--preview-arrow-top',
      '-8px'
    );

  } else {

    /*
     * Right / Left:
     * Arrow points toward thumbnail vertically
     */
    arrowTop =
      imageRect.top +
      (imageRect.height / 2) -
      top -
      7;

    preview.style.setProperty(
      '--preview-arrow-top',
      arrowTop + 'px'
    );
  }


  /*
   * Position classes
   */
  preview.classList.toggle(
    'int-quick-order-image-preview--bottom',
    position === 'bottom'
  );

  preview.classList.toggle(
    'int-quick-order-image-preview--left',
    position === 'left'
  );

  preview.classList.toggle(
    'int-quick-order-image-preview--right',
    position === 'right'
  );
}


/*
 * Window scrolling
 */
window.addEventListener(
  'scroll',
  positionPreview,
  {
    passive: true
  }
);


/*
 * Scroll inside modal/container
 */
document.addEventListener(
  'scroll',
  positionPreview,
  {
    passive: true,
    capture: true
  }
);


/*
 * Window resize
 */
window.addEventListener(
  'resize',
  positionPreview
);


/*
 * Close preview
 */
function closePreview() {

  const preview = document.getElementById(
    'int-quick-order-image-preview'
  );

  if (!preview) {
    return;
  }

  preview.classList.remove(
    'int-quick-order-image-preview--active'
  );

  preview.setAttribute(
    'aria-hidden',
    'true'
  );

  const previewImage = preview.querySelector(
    '.int-quick-order-image-preview__image'
  );

  if (previewImage) {
    previewImage.removeAttribute('src');
  }

  preview._targetImage = null;

  preview.classList.remove(
    'int-quick-order-image-preview--left'
  );
}